import {
  UnifiedInput,
  ControlType,
} from 'src/app/shared/components/unified-custom-input/unified-input.types';

export const deviceDetailsInputConfig: UnifiedInput[] = [
  {
    controlType: ControlType.TEXT,
    type: 'text',
    placeholder: 'MAC ID',
    label: 'MAC ID',
    value: '',
    detail: false,
    name: 'macId',
    validator: 'macId',
    required: true
  }
];
